export default {
    install(app) {
        app.config.globalProperties.$alerts = {
            toast: {
                success: (message) => {
                    app.config.globalProperties.$toast.clear();
                    app.config.globalProperties.$toast.success(message, {
                        position: 'bottom-left' ,
                        duration: 6000
                    })
                },
                error: (message) => {
                    app.config.globalProperties.$toast.clear();
                    app.config.globalProperties.$toast.error(message, {
                        position: 'bottom-left' ,
                        duration: 6000
                    })
                },
                warning: (message) => {
                    app.config.globalProperties.$toast.clear();
                    app.config.globalProperties.$toast.warning(message, {
                        position: 'bottom-left' ,
                        duration: 6000
                    })
                },
                info: (message) => {
                    app.config.globalProperties.$toast.clear();
                    app.config.globalProperties.$toast.info(message, {
                        position: 'bottom-left' ,
                        duration: 6000
                    })
                },
            },
            swal: {
                success: (message) =>
                    app.config.globalProperties.$swal({
                        title: message,
                        icon: 'success',
                        showConfirmButton: true,
                        showCancelButton: false,
                        confirmButtonColor: '#ff5252',
                        confirmButtonText: 'إغلاق',
                        timer: 5000,
                        reverseButtons: true
                    }),
                error: (message) =>
                    app.config.globalProperties.$swal({
                        title: message,
                        icon: 'error',
                        showConfirmButton: true,
                        showCancelButton: false,
                        confirmButtonColor: '#ff5252',
                        confirmButtonText: 'إغلاق',
                        timer: 5000,
                        reverseButtons: true
                    }),
                warning: (message, confirm_button) =>
                    app.config.globalProperties.$swal({
                        title: message,
                        icon: 'warning',
                        showConfirmButton: true,
                        showCancelButton: true,
                        confirmButtonColor: '#144265',
                        cancelButtonColor: '#ff5252',
                        confirmButtonText: confirm_button,
                        cancelButtonText: 'إغلاق',
                        timer: 5000,
                        reverseButtons: true
                    }),
            },
        }
    }
}